import { render } from "./utilizadorFilter.vue?vue&type=template&id=619e8696"
import script from "./utilizadorFilter.vue?vue&type=script&lang=js"
export * from "./utilizadorFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__